<template>
  <div class="full-screen container">

      <div class="form-group">
        <label for="title">Title</label>
        <input class="form-control" id="title" v-model="milestone.title">
      </div>

      <div class="form-group">
        <label for="date">Date</label>
        <input class="form-control" type="date" id="date" @change="setDate" :value="formatted.date">
      </div>

      <div class="form-group">
        <label for="time">Time</label>
        <input class="form-control" type="time" id="time" @change="setTime" :value="formatted.time">

        <p class="form-text text-muted">
          Leave time blank for an all-day milestone.
        </p>
      </div>

      <div class="form-group d-flex justify-content-between pt-5">
        <router-link v-if="!editing" to="/" class="btn btn-outline-warning">Cancel</router-link>
        <button v-if="editing" @click="destroy" class="btn btn-outline-danger">Delete</button>
        <button v-if="editing" @click="update" class="btn btn-success">Save</button>
        <button v-else @click="save" class="btn btn-success">Save</button>
      </div>

    </div>
</template>

<script>
  import store from '../store/store'
  import format from 'date-fns/format'
  import milestone from '../factory/milestone'
  import midnightToday from '../utils/midnightToday'

  export default {
    methods: {
      setDate ({target}) {
        const date = target.value.split('-')

        if (date.length >= 3) {
          /** -1 for the month to make it 0 based */
          this.milestone.date.setFullYear(date[0], date[1] - 1, date[2])
        } else {
          this.milestone.date = midnightToday()
        }
      },
      setTime ({target}) {
        const time = target.value.split(':')

        if (time.length >= 2) {
          this.milestone.date.setHours(time[0], time[1])
        } else {
          this.milestone.date.setHours(0, 0)
        }
      },
      save () {
        store.commit('addMilestone', this.milestone)
        return this.$router.push('/')
      },
      update () {
        store.commit('updateMilestone', this.milestone)
        return this.$router.push('/')
      },
      destroy () {
        store.commit('removeMilestone', this.milestone)
        return this.$router.push('/')
      }
    },
    computed: {
      editing () {
        return this.$route.name === 'EditMilestone' && this.$route.params.slug
      },
      formatted () {
        return {
          date: format(this.milestone.date, 'YYYY-MM-DD'),
          time: this.milestone.date.getHours() === 0 ? null : format(this.milestone.date, 'HH:mm')
        }
      },
      milestone () {
        if (this.editing) {
          return store.state.milestones.find(milestone => {
            return milestone.slug === this.$route.params.slug
          })
        }
        return milestone()
      }
    }
  }
</script>

<style type="text/scss">
</style>
